import * as Sentry from "@sentry/capacitor";
import logger from "../sentryLogger";
import {registerPlugin} from "@capacitor/core";
import {Capacitor} from "@capacitor/core";

interface CashDrawerPlugin {
    open(): Promise<void>;
}

const IS_MOCK = import.meta.env.REACT_APP_MOCK_API === "true";

const cashDrawer = registerPlugin<CashDrawerPlugin>("CashDrawer");

export const openCashDrawer = async (isTraining = false) => {
    if (isTraining || IS_MOCK) {
        return Promise.resolve();
    }

    return cashDrawer.open().catch((err) => {
        if (Capacitor.isNativePlatform()) {
            logger.error("Failed to open cash drawer.");
            Sentry.captureException(err);
            throw Error(err);
        } else {
            console.debug(err); // this is not expected to work on web, no need to notify sentry
        }
    });
};
